import React from 'react';
import { Clock, Sparkles } from 'lucide-react';
import { services } from '../data/mock';
import { contactInfo } from '../data/mock';

const Services = () => {
  const handleWhatsAppClick = (serviceName) => {
    const message = `Olá! Gostaria de agendar o serviço: ${serviceName}`;
    window.open(
      `https://wa.me/${contactInfo.whatsapp}?text=${encodeURIComponent(message)}`,
      '_blank'
    );
  };

  return (
    <section id="servicos" className="section bg-white">
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-[var(--color-rose-gold)] uppercase tracking-[0.2em] text-sm font-medium">
            Nossos Serviços
          </span>
          <h2 
            className="text-4xl md:text-5xl text-[var(--color-brown-dark)] mt-4 mb-4"
            style={{ fontFamily: 'var(--font-display)' }}
          >
            Menu de Serviços
          </h2>
          <div className="decorative-line" />
          <p className="text-[var(--color-text-light)] mt-6 max-w-xl mx-auto">
            Cada técnica é escolhida cuidadosamente para realçar a beleza natural do seu olhar
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {services.map((service, index) => (
            <div
              key={service.id}
              className="service-card card p-8 animate-fade-in-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="flex justify-between items-start mb-4">
                <div>
                  <h3 
                    className="text-2xl text-[var(--color-brown-dark)] mb-2"
                    style={{ fontFamily: 'var(--font-display)' }}
                  >
                    {service.name}
                  </h3>
                  <div className="flex items-center gap-2 text-[var(--color-text-light)] text-sm">
                    <Clock size={14} />
                    <span>{service.duration}</span>
                  </div>
                </div>
                <div className="text-right">
                  {service.price ? (
                    <span 
                      className="text-3xl font-medium text-[var(--color-rose-gold)]"
                      style={{ fontFamily: 'var(--font-display)' }}
                    >
                      R$ {service.price.toFixed(2).replace('.', ',')}
                    </span>
                  ) : (
                    <span className="text-sm text-[var(--color-rose-gold)] font-medium uppercase tracking-wider">
                      A combinar
                    </span>
                  )}
                </div>
              </div>
              
              <p className="text-[var(--color-text-light)] text-sm leading-relaxed mb-6">
                {service.description}
              </p>
              
              <button
                onClick={() => handleWhatsAppClick(service.name)}
                className="w-full btn-secondary text-sm py-3"
              >
                Agendar Este Serviço
              </button>
            </div>
          ))}
        </div>

        {/* Additional Info */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-3 bg-[var(--color-cream)] rounded-full px-8 py-4">
            <Sparkles size={20} className="text-[var(--color-rose-gold)]" />
            <span className="text-[var(--color-text-light)] text-sm">
              Valores de manutenção variam conforme avaliação (15, 20 ou 30 dias)
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
